import { render, staticRenderFns } from "./SamSidebar.vue?vue&type=template&id=50807e23&scoped=true&shadow"
import script from "./SamSidebar.vue?vue&type=script&lang=js&shadow"
export * from "./SamSidebar.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamSidebar.vue?vue&type=style&index=0&id=50807e23&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "50807e23",
  null
  ,true
)

export default component.exports